import React from "react";
import { Form, Formik } from "formik";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import * as yup from "yup";

import { hooks } from "../hooks";
import { components } from "../components";
import AuthLayout from "../services/auth/jwt/withAuth";
import { showErrorToast, showSuccessToast } from "../components/apps/AppError";
import { WITHDRAW_REQUEST } from "../graphql/mutations/transaction";
import { useQueryProfile } from "../graphql/apollo/useQuery";
import { AppSubmitButton, AppTextField } from "../components/apps";
import { TABS } from "../constants/app_routes";
import { useDispatch } from "../store/store";
import { setScreen } from "../store/slices/tabSlice";
import { currentBranch } from "../constants/constants";

export const WithdrawScreen: React.FC = () => {
  const navigate = hooks.useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const validationSchema = yup.object({
    amount: yup.number(),
  });

  const renderImageBackground = (): JSX.Element => {
    return <components.Background version={1} />;
  };

  const renderHeader = (): JSX.Element => {
    return <components.Header title={t("withdraw")} goBack={true} />;
  };
  const { refetch } = useQueryProfile();

  const [withdrawRequest] = useMutation(WITHDRAW_REQUEST, {
    onCompleted: (data) => {
      if (data.withdrawRequest) {
        showSuccessToast();
        refetch();
        navigate(-1);
        dispatch(setScreen(TABS.PROFILE));
      }
    },
    onError: (err) => {
      showErrorToast(err.message);
    },
  });

  const handleSubmit = (data: any) => {
    withdrawRequest({
      variables: { amount: data.amount, password: "", branch: currentBranch },
    });
  };

  return (
    <AuthLayout>
      {renderImageBackground()}
      {renderHeader()}
      <main className="container" style={{ paddingBottom: 0, marginTop: 40 }}>
        <div
          className="custom-block"
          style={{ padding: 20, marginTop: 20, marginBottom: 10 }}
        >
          <Formik
            validateOnChange
            initialValues={{ amount: 0 }}
            onSubmit={(data: any) => handleSubmit(data)}
            validationSchema={validationSchema}
          >
            {() => (
              <Form style={{ textAlign: "left" }} noValidate autoComplete="off">
                <AppTextField
                  placeholder={t("withdrawAmount")}
                  name="amount"
                  label={t("withdrawAmount")}
                  type="number"
                />
                <AppSubmitButton
                  label={t("confirm")}
                  disabled={false}
                  loading={false}
                />
              </Form>
            )}
          </Formik>
        </div>
      </main>
    </AuthLayout>
  );
};
